import { MessageCircle } from "lucide-react";
import { WHATSAPP_LINK } from "@/lib/whatsapp";

const WhatsAppFloat = () => {
  return (
    <a
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50 bg-[#25D366] hover:bg-[#20BA5A] text-white px-4 py-3 sm:px-6 sm:py-3 rounded-full flex items-center gap-2 shadow-[var(--shadow-strong)] hover:scale-105 active:scale-95 transition-[var(--transition-smooth)] font-semibold touch-manipulation"
      aria-label="Orçamento Rápido pelo WhatsApp"
    >
      <MessageCircle className="w-6 h-6 sm:w-5 sm:h-5" />
      <span className="hidden sm:inline text-sm sm:text-base">Orçamento Rápido</span>
    </a>
  );
};

export default WhatsAppFloat;
